// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".application-template-select-tab .box-footer[data-v-ef458450]{padding:10px 0 0 0!important}.application-template-select-tab .box-footer .update-btn[data-v-ef458450]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
